import _merge from 'lodash/merge';
import { Lightning } from '@lightningjs/sdk';
import { getInitialStyle, defaultContext } from './tracksPanel.style';
import { SELECTED_SIGNAL } from '../../../../tornado/signals';
import { TrackItem } from '../trackItem/trackItem.component';

export class TracksPanel extends Lightning.Component {
  static _template() {
    return _merge(
      {
        Title: {},
        Items: {},
      },
      getInitialStyle(),
    );
  }

  _construct() {
    this._style = defaultContext;
    this._items = [];
    this._index = 0;
  }

  get title() {
    return this.tag('Title').text.text;
  }

  set title(value) {
    this.tag('Title').text.text = value;
  }

  get items() {
    return this._items;
  }

  set items(value) {
    this._items = value || [];

    this.patch({
      Items: {
        children: this._items.map(track => ({
          type: TrackItem,
          label: track.label,
          w: this.finalW,
          isSelected: Boolean(track.active),
        })),
      },
    });
    this._refocus();
  }

  get w() {
    return super.w;
  }

  set w(value) {
    super.w = value;
    this.tag('Items').children.forEach(child => {
      child.w = value;
    });
  }

  get index() {
    return this._index;
  }

  set index(value) {
    this._index = value;
  }

  setFocusToSelectedItem() {
    const selectedItemIndex = this.tag('Items').children.findIndex(({ isSelected }) => isSelected);
    this.index = selectedItemIndex >= 0 ? selectedItemIndex : 0;
    this._refocus();
  }

  highlightPreferredTrack(trackId) {
    const trackToHighLight = this._items.findIndex(({ id }) => id === trackId);

    if (trackToHighLight >= 0) {
      const items = this.tag('Items').children;
      for (let i = 0; i < items.length; i += 1) {
        items[i].isSelected = false;
      }
      items[trackToHighLight].isSelected = true;
    }
    this.index = trackToHighLight >= 0 ? trackToHighLight : 0;
    this._refocus();
  }

  _getFocused() {
    return this.tag('Items').children[this.index];
  }

  _handleUp() {
    if (this.index > 0) {
      this.index -= 1;

      return true;
    }

    return false;
  }

  _handleDown() {
    if (this.index < this.items.length - 1) {
      this.index += 1;

      return true;
    }

    return false;
  }

  _handleEnter() {
    const selectedView = this.tag('Items').children[this._index];
    if (selectedView) {
      this.tag('Items').children.forEach(child => {
        child.isSelected = child === selectedView;
      });
      this.signal(SELECTED_SIGNAL, this.items[this._index]);
    }
  }
}
